import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoCard from "../../components/infocard/InfoCard";
import DescriptionCard from "../../components/DescriptionCard/DescriptionCard";
import "./GrowthHackTableData.scss";
import BulletCard from "../../components/bulletcard/BulletCard";
import ServiceTags from "../../components/servicetags/ServiceTags";
import CredentialCard from "../../components/credentialcard/CredentialCard";
import GHEmailTrigger from "../../components/GH-EmailTrigger/GH-EmailTrigger";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import AppBarHeader from "../../components/AppBarHeader/AppBarHeader";

export default function GrowthHackTableData() {
  const navigate = useNavigate();
  const location = useLocation();
  const [individualGHData, setIndividualGHData] = useState([]);
  const [growthHackContacts, setGrowthHackContacts] = useState([]);
  const [growthHackInfo, setGrowthHackInfo] = useState(null);
  const [visibleCredentials, setVisibleCredentials] = useState(2);
  const [showAll, setShowAll] = useState(false);

  const { handleShare, isSharing } = GHEmailTrigger();
  console.log("GH state:", { individualGHData, growthHackContacts, growthHackInfo });
  
  useEffect(() => {

    if (location.state) {
      const { individualGHData: creds, growthHackContacts: contacts, growthHackInfo: info } = location.state;
      if (creds) {
        console.log('Received individualGHData:', creds);
        setIndividualGHData(creds);
      }
      if (contacts) {
        console.log('Received growthHackContacts:', contacts);
        setGrowthHackContacts(contacts);
      }
      if (info) {
        console.log('Received growthHackInfo:', info);
        setGrowthHackInfo(info);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (!location.state) {
      const t = setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 0);
      return () => clearTimeout(t);
    }
  }, [location.state, navigate]);

  const handleBack = ()=>{
    navigate(-1);
  };

  const handleLoadMore = () => {
    setVisibleCredentials(prev => prev + 2);
  };

  const handleShowAll = () => {
    setShowAll(true);
  };

  const handleHideAll = () => {
    setShowAll(false);
    setVisibleCredentials(2);
  };

const serviceTags = useMemo(() => {
  if (!Array.isArray(growthHackContacts)) return [];

  const groupMap = new Map();

  growthHackContacts.forEach((item) => {
    const service = (item?.GrowthHackService || '').trim();
    const emailsStr = (item?.ContactEmail || '').trim();
    const namesStr = (item?.ContactName || '').trim();

    const emails = emailsStr
      .split(';')
      .map((s) => s.trim())
      .filter((v) => v && v.toLowerCase() !== 'tbd');
    const names = namesStr
      .split(';')
      .map((s) => s.trim())
      .filter((v) => v && v.toLowerCase() !== 'tbd');

    const maxLen = Math.max(emails.length, names.length);
    if (maxLen === 0) return;

    const people = [];
    for (let i = 0; i < maxLen; i++) {
      const mail = emails[i] || '';
      const name = names[i] || '';
      if (!mail && !name) continue;
      if (mail && (!mail.includes('@') || !mail.includes('.'))) {
        continue;
      }
      people.push({ mail, name, profile_url: '' });
    }

    if (people.length === 0) return;

    const key = service || 'Unknown Service';
    if (!groupMap.has(key)) groupMap.set(key, []);
    groupMap.get(key).push(...people);
  });

  const tags = Array.from(groupMap.entries()).map(([title, people]) => {
    const seen = new Set();
    const uniquePeople = people.filter((p) => {
      const key = (p.mail || p.name || '').toLowerCase();
      if (!key) return false;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    return { title, people: uniquePeople };
  });

  return tags;
}, [growthHackContacts]);

const formattedDate = useMemo(() => {
  const raw = growthHackInfo?.Date;
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return String(raw);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}, [growthHackInfo?.Date]);

const credentialCards = useMemo(() => {
  const toDisplayDate = (val) => {
    if (!val) return "";
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return String(val);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  if (!Array.isArray(individualGHData)) return [];
  return individualGHData.map((item, idx) => {
    const title = item?.["Engagement Name"] || item?.Title || `Credential ${idx + 1}`;
    const endDate = item?.["Engagement Start Date"] || item?.Date;
    const date = toDisplayDate(endDate);
    const confLabel = item?.["Client Confidentiality"] || "Confidentiality";
    const color = /level[- ]?1/i.test(confLabel) ? "red" : "purple";
    const contacts = [item?.["Engagement Partner"]].filter(Boolean);
    const descriptionRaw = item?.SummaryGenAi || "";
    const description = String(descriptionRaw).replace(/<br\s*\/>/gi, " \u2022 ").replace(/<[^>]+>/g, "");
    const url = item?.["URL"] || "";
    return {
      title,
      date,
      confidentiality: { label: confLabel, color },
      contacts,
      description,
      url,
    };
  });
}, [individualGHData]);
 
  return (
    <>
    <AppBarHeader/>
    <div className="info-page-container container-fluid">
      <div className="row">
        <div className="col-12 data-page-header-flex">
          <Button
            variant="outlined"
            size="small"
            startIcon={<ArrowBackIcon />}
            className="top-button"
            onClick={handleBack}
          >
            Back
          </Button>
          <h2 className="data-page-heading">
            {growthHackInfo?.ClientName ? (
              <span className="client-name-highlight">{growthHackInfo.ClientName}</span>
            ) : 'Client'}
            {' : Growth Hack Detail'}
          </h2>
          <Button variant="outlined" size="small" className="top-button" onClick={() => handleShare(growthHackInfo, serviceTags)} disabled={isSharing}>
            {isSharing ? <CircularProgress size={18} color="inherit" /> : 'Share'}
          </Button>
        </div>
      </div>
      <div className="main-container row justify-content-center mt-4">
        <div className="col-12">
          <InfoCard 
            title={growthHackInfo?.GrowthHackTitleGenAI || growthHackInfo?.GrowthHackTitle}
            growthHackType={growthHackInfo?.GrowthHackType}
            GrowthHackSubCategory={growthHackInfo?.GrowthHackSubCategory}
            Urgency={growthHackInfo?.Urgency}
            Date={formattedDate}
            GrowthHackDescriptionGenAI={growthHackInfo?.GrowthHackSummaryGenAI}
          />
           <DescriptionCard 
            GrowthHackSummaryGenAI={growthHackInfo?.GrowthHackSummaryGenAI}
          />
          <div className="ai-container bg-gradiant">
            <Button className="button-gradiant" color="inherit">AI Suggestions</Button>
            <BulletCard
              nextStepsText={growthHackInfo?.NextStepGenAI}
              recommendationsText={growthHackInfo?.GrowthHackDescriptionGenAI}
            />
            <ServiceTags tags={serviceTags} />
          </div>

          <div className="cred-container">
            <div className="cred-title">Credentials</div>
            <div className="cred-grid">
              {credentialCards && credentialCards.length > 0 ? (
                credentialCards.slice(0, showAll ? credentialCards.length : visibleCredentials).map((card, idx) => (
                  <CredentialCard key={idx} data={card} />
                ))
              ) : (
                <div className="not-available-credentials">Not available</div>
              )}
            </div>
            {credentialCards && credentialCards.length > 2 && (
              <div className="cred-buttons">
                {credentialCards.length > visibleCredentials && !showAll && (
                  <>
                    <Button 
                      variant="outlined" 
                      className="cred-button load-more-btn"
                      onClick={handleLoadMore}
                    >
                      Load More
                    </Button>
                    <Button 
                      variant="outlined" 
                      className="cred-button show-all-btn"
                      onClick={handleShowAll}
                    >
                      Show All
                    </Button>
                  </>
                )}
                {(showAll || visibleCredentials > 2) && (
                  <Button 
                    variant="outlined" 
                    className="cred-button hide-all-btn"
                    onClick={handleHideAll}
                  >
                    Hide All
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
